import React from 'react';

import { ratesService } from './rates-service';

import './styles/rates-bio.scss';

const StrategyBio = ({ strategy, setShowBio }) => {
  const columns = ratesService.getStrategyBioColumns(strategy);
  const stats = columns.map((column, index) => {
    const className = column.label.replace(/ /g, '-').toLowerCase();
    return (
      <div className={className} key={index}>
        <span className="label">{column.label}</span>
        <span className="value">{column.value}</span>
      </div>
    );
  });

  return (
    <div className="strategy rates-bio">
      <div className="stats">
        <div className="toggle">
          <button onClick={() => setShowBio(false)}>Hide</button>
        </div>
        <div className="strategy-name">{strategy.strategy_name}</div>
        {stats}
      </div>
    </div>
  );
};

export default StrategyBio;
